/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type RenderTemplateByIDRequestBody = {
  /**
   * The input data to render the template with
   */
  arguments: { [k: string]: any };
};

/** @internal */
export type RenderTemplateByIDRequestBody$Outbound = {
  arguments: { [k: string]: any };
};

/** @internal */
export const RenderTemplateByIDRequestBody$outboundSchema: z.ZodMiniType<
  RenderTemplateByIDRequestBody$Outbound,
  RenderTemplateByIDRequestBody
> = z.object({
  arguments: z.record(z.string(), z.any()),
});

export function renderTemplateByIDRequestBodyToJSON(
  renderTemplateByIDRequestBody: RenderTemplateByIDRequestBody,
): string {
  return JSON.stringify(
    RenderTemplateByIDRequestBody$outboundSchema.parse(
      renderTemplateByIDRequestBody,
    ),
  );
}
